export const isVideoMetrics = (value) => 'framesPerSecond' in value;
//# sourceMappingURL=typeGuards.js.map